import React, { Component } from 'react'
import { DateRangePicker as DRP } from "react-dates";
import 'react-dates/lib/css/_datepicker.css'
const uuidv4 = require('uuid/v4')

class DateRangePicker extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            startDate: this.props.startDate || null,
            endDate: this.props.endDate || null,
            focused: null,
        }

        const defaultCallback = () => { }
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
        this.onDatesChange = this.onDatesChange.bind(this)
        this.onFocusPicker = this.onFocusPicker.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            this.onChange(selectedOption.value)
        });
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            startDate: nextProps.startDate || null,
            endDate: nextProps.endDate || null
        });
    }

    onDatesChange({ startDate, endDate }) {
        if (startDate) {
            startDate.startOf('day')
        }
        if (endDate) {
            endDate.endOf('day')
        }
        this.setState({
            startDate: startDate,
            endDate: endDate,
        }, () => {
            this.onChange(this.state.startDate, this.state.endDate)
        })
    }

    onFocusPicker(focused) {
        this.setState({ focused: focused }, () => {
            if (this.props.onFocus) {
                this.props.onFocus()
            }
        })
    }
    render() {

        return (
            <DRP
                small
                minimumNights={0}
                numberOfMonths={this.props.numberOfMonths || 2}
                isOutsideRange={() => false}
                onDatesChange={this.onDatesChange}
                focusedInput={this.state.focused}
                onFocusChange={this.onFocusPicker}
                startDateId={'start-date' + uuidv4()}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                endDateId={'end-date-' + uuidv4()}
                showClearDates={true}
                showDefaultInputIcon={true}
                
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
            />
        )
    }
}

export default DateRangePicker





// WEBPACK FOOTER //
// ./src/common/date/daterangepicker.component.jsx